<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  
  export let tag: string;
  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch('tagSelect', { tag });
  }
</script>

<div class="industry-tag-container">
  <span 
    class="context-tag" 
    class:tag-healthcare={tag === "Healthcare"}
    class:tag-transportation={tag === "Transportation"}
    class:tag-culture={tag === "Culture & Arts"}
    class:tag-fintech={tag === "Fintech"}
    class:tag-emerging-tech={tag === "Emerging Tech"}
    class:tag-education={tag === "Education"}
    class:tag-design-research={tag === "Design Research"}
    on:click={handleClick}
  >
    {tag}
  </span>
</div>

<style>
  .industry-tag-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .industry-tag {
    @apply inline-block px-4 py-1 text-xs font-medium cursor-pointer transition-all duration-300;
    color: black;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 1);
  }

  .industry-tag:hover {
    background-color: black;
    color: white;
  }

  /* Healthcare */
  .industry-tag[data-industry="Healthcare"] {
    background-image: 
      linear-gradient(45deg, transparent 45%, rgba(0,0,0,0.1) 45%, rgba(0,0,0,0.1) 55%, transparent 55%),
      linear-gradient(-45deg, transparent 45%, rgba(0,0,0,0.1) 45%, rgba(0,0,0,0.1) 55%, transparent 55%);
    background-size: 8px 8px;
  }

  /* Culture */
  .industry-tag[data-industry="Culture"] {
    background-image: 
      radial-gradient(rgba(0,0,0,0.1) 15%, transparent 16%),
      radial-gradient(rgba(0,0,0,0.1) 15%, transparent 16%);
    background-size: 8px 8px;
    background-position: 0 0, 4px 4px;
  }

  /* Transportation */
  .industry-tag[data-industry="Transportation"] {
    background-image: 
      linear-gradient(90deg, transparent 50%, rgba(0,0,0,0.1) 50%);
    background-size: 6px 100%;
  }

  /* Fintech */
  .industry-tag[data-industry="Fintech"] {
    background-image: 
      linear-gradient(0deg, transparent 45%, rgba(0,0,0,0.1) 45%, rgba(0,0,0,0.1) 55%, transparent 55%),
      linear-gradient(90deg, transparent 45%, rgba(0,0,0,0.1) 45%, rgba(0,0,0,0.1) 55%, transparent 55%);
    background-size: 10px 10px;
  }

  /* Emerging Tech */
 
  .industry-tag[data-industry="Emerging Tech"] {
    background-image: 
      linear-gradient(30deg, rgba(0,0,0,0.1) 12%, transparent 12.5%, transparent 87%, rgba(0,0,0,0.1) 87.5%, rgba(0,0,0,0.1)),
      linear-gradient(150deg, rgba(0,0,0,0.1) 12%, transparent 12.5%, transparent 87%, rgba(0,0,0,0.1) 87.5%, rgba(0,0,0,0.1));
    background-size: 10px 16px;
  }

  /* Design Futures */
  .industry-tag[data-industry="Design Futures"] {
    background-image: 
      linear-gradient(45deg, rgba(0,0,0,0.1) 25%, transparent 25%),
      linear-gradient(-45deg, rgba(0,0,0,0.1) 25%, transparent 25%);
    background-size: 8px 16px;
  }

  /* Education */
  .industry-tag[data-industry="Education"] {
    background-image: 
      linear-gradient(0deg, transparent 90%, rgba(0,0,0,0.1) 90%),
      linear-gradient(90deg, transparent 90%, rgba(0,0,0,0.1) 90%);
    background-size: 8px 8px;
  }

  /* Speculative Design */
  .industry-tag[data-industry="Speculative Design"] {
    background-image: 
      linear-gradient(0deg, transparent 47%, rgba(0,0,0,0.1) 47%, rgba(0,0,0,0.1) 53%, transparent 53%),
      linear-gradient(90deg, transparent 47%, rgba(0,0,0,0.1) 47%, rgba(0,0,0,0.1) 53%, transparent 53%);
    background-size: 12px 12px;
  }

  /* Public Health */
  .industry-tag[data-industry="Public Health"] {
    background-image: 
      linear-gradient(45deg, rgba(0,0,0,0.1) 25%, transparent 25%, transparent 75%, rgba(0,0,0,0.1) 75%, rgba(0,0,0,0.1));
    background-size: 10px 10px;
  }

</style> 